import { useLocalization } from '@magicdoorinc/ui';
import { Show } from 'solid-js';
import type { Component, JSX } from 'solid-js';

export const CustomViewColumnLabel: Component<{ title?: JSX.Element; isMagicTag?: boolean }> = (props) => {
  const { t } = useLocalization();

  return (
    <div class="flex min-w-0 items-center gap-2">
      <span class="truncate">{props.title}</span>
      <Show
        when={props.isMagicTag}
        fallback={
          <span class="shrink-0 rounded-full bg-grey px-1.5 py-0.5 text-xs font-medium uppercase text-text-03">{t('System')}</span>
        }>
        <span class="shrink-0 rounded-full bg-primary/10 px-1.5 py-0.5 text-xs font-medium uppercase text-primary">{t('Magic tag')}</span>
      </Show>
    </div>
  );
};
